import { createContext } from "react";

const VistaContext = createContext();
export default VistaContext;
